import Usuario from '@pages/operadora/usuario';

export default [
    {
        path: '/operadora/usuario',
        name: 'operadora.usuario.list',
        component: Usuario,
    },
];
